export default "Frühe randomisierte Studie zu tibetischem Yoga bei Lymphom-Patient:innen – mit Verbesserungen in schlafbezogenen Outcomes."